
import Logo from "./Logo";
import HeaderMenuLeft from "./HeaderMenuLeft";
import HeaderMobile from "./HeaderMobile";
import HeaderMobileSearch from "./HeaderMobileSearch";
import HeaderSearch from "./HeaderSearch";
import HeaderUser from "./HeaderUser";
import HeaderLogin from "./HeaderLogin";
import HeaderAdmin from "./HeaderAdmin";
import HeaderBasket from "./HeaderBasket";
import HeaderFavorites from "./HeaderFavorites.vue";
export default {
    name: "Header",
    components: {HeaderFavorites, HeaderBasket, HeaderAdmin, HeaderLogin, HeaderUser, HeaderSearch, HeaderMobileSearch, HeaderMobile, HeaderMenuLeft, Logo},
    props: ['full'],
    data() {
        return {
            hasPassedHero: false,
            scrollFrame: null,
        }
    },
    mounted() {
        window.addEventListener('scroll', this.scheduleHeaderUpdate, {passive: true});
        window.addEventListener('resize', this.scheduleHeaderUpdate);
        window.addEventListener('pageshow', this.scheduleHeaderUpdate);
        // Nuxt emits this after the page transition, before restoring its scroll position.
        this.$nuxt.$on('triggerScroll', this.scheduleHeaderUpdate);
        this.$nextTick(this.updateHeaderTheme);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.scheduleHeaderUpdate);
        window.removeEventListener('resize', this.scheduleHeaderUpdate);
        window.removeEventListener('pageshow', this.scheduleHeaderUpdate);
        this.$nuxt.$off('triggerScroll', this.scheduleHeaderUpdate);
        if (this.scrollFrame !== null) {
            window.cancelAnimationFrame(this.scrollFrame);
        }
    },
    watch: {
        $route() {
            this.$nextTick(this.scheduleHeaderUpdate);
        },
    },
    computed: {
        isOverHero() {
            return this.full && !this.hasPassedHero;
        },
        basketCount () {
            return this.$store.state.basket.count
        },
        menuCatalogState () {
            return this.$store.state.dropdownMenu.catalog
        },
        menuOpenState () {
            return this.menuCatalogState
                || this.$store.state.dropdownMenu.about
        },
    },
    methods: {
        scheduleHeaderUpdate() {
            if (this.scrollFrame !== null || this._isBeingDestroyed || this._isDestroyed) {
                return;
            }
            this.scrollFrame = window.requestAnimationFrame(() => {
                this.scrollFrame = null;
                this.updateHeaderTheme();
            });
        },
        updateHeaderTheme() {
            if (!this.full) {
                this.hasPassedHero = false;
                return;
            }

            const hero = document.querySelector('.hero');
            // Switch before the fixed header overlaps the content below the hero.
            this.hasPassedHero = !hero
                || hero.getBoundingClientRect().bottom <= this.$el.getBoundingClientRect().bottom;
        },
    },
}
